__turbopack_context__.v({
  "accent": "Link-module__vV4qxa__accent",
  "documentIcon": "Link-module__vV4qxa__documentIcon",
  "externalIcon": "Link-module__vV4qxa__externalIcon",
  "githubIcon": "Link-module__vV4qxa__githubIcon",
  "icon": "Link-module__vV4qxa__icon",
  "label": "Link-module__vV4qxa__label",
  "link": "Link-module__vV4qxa__link",
  "mailToIcon": "Link-module__vV4qxa__mailToIcon",
});
